import {AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Inject, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {NgbActiveModal, NgbModal, NgbModalOptions, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {ToastrService} from 'ngx-toastr';
import { ERP_AFFICHAGES_API, ErpAffichagesApi } from '@erp/affichages';
import {AddTaxeComponent} from '../../../gestionProduits/add-product/add-taxe/add-taxe.component';
import {Product} from '../../../../../models/Product';
import {ProductsService} from '../../../../../services/products/products.service';
import {Taxe, TaxeService} from '../../../../parametre/taxe-tva/parametre-taxe/taxe.service';
import {Tva, TvaService} from '../../../../parametre/taxe-tva/parametre-tva/tva.service';
import {Marque} from '../../../../../models/marque';
import {Categorie} from '../../../../../models/categorie';
import {Unite} from '../../../../../models/Unite';
import {Observable, of, throwError} from 'rxjs';
import {catchError, finalize, switchMap, tap} from 'rxjs/operators';
import {StationService} from '../../../../../services/station.service';
import {Prix, PrixService} from '../../../../parametre/liste-prix/prix.service';
interface PriceBlockError {
    bascul_calcul: string;
    regles: string;
}
interface WarehouseBlockErrors {
    entrepot_id: string  ,
    minimum: string,
    maximum: string
}
@Component({
  selector: 'app-add-product-modal',
  templateUrl: './add-product-modal.component.html',
  styleUrls: ['./add-product-modal.component.scss']
})
export class AddProductModalComponent implements OnInit, AfterViewInit {
    @ViewChild('modalLG') modalTemplate!: TemplateRef<any>;
    @ViewChild('addtaxe') addtaxe?: AddTaxeComponent;
    @Output() closeModal = new EventEmitter<any>();
    @Input() clientId!: number;
    @Input() stationId!: number;
    fenetre: number = 0;
    currentUser = JSON.parse(localStorage.getItem('currentUser'));
    private modalRef!: NgbModalRef;
    prixVente: number = null;
    priceType: string = 'HT';
    priceType2: string = 'HT';
    lastCreatedProductId: number | null = null;
    isLoading = false;
    product: Product = {

        is_archive: false,
        type: '',
        nom: '',
        tva_id: 0,
        taxe_id: 0,
        taxes: [],
        prix_unitaires: 0,
        autoriser_vente_stock_vide : false,
        produit_avec_numero_serie : false,
        result_ht: 0,
        result_ttc: 0,
        image: undefined,
        marque_id: 0,
        categories_id: 0,
        unite_id: 0,
        ref_interne: '',
        ref_fabricant: undefined,
        description: undefined,
        station_id: 0,
        client_id: 0,
        liste_prix: {
            prix_id: 0,
            bascul_calcul: '',
            regles: '',
            montant: 0,
            result_ttc: 0,
            result_ht: 0,
            client_id: 0,
            station_id: 0
        },
        informations_logistique: [
            {
                entrepot_id: 0,
                minimum: 0,
                maximum: 0,
                is_active_alert: false,
                client_id: 0,
                station_id: 0
            }
        ]
    };
    priceHT = 0;
    private calculating: boolean = false;
    priceTTC = 0;
    public_ht = 0;
    public_ttc = 0;
    marques: Marque[] = [];
    categories: Categorie[] = [];
    hasAddedPrice: boolean = false;
    availablePriceLists: Prix[] = [];
    margePourcentage: number | null = null;
    unites: Unite[] = [];
    taxes: Taxe[] = [];
    warehouses = [
        {
            entrepot_id : null,
            minimum: null,
            maximum: null,
            is_active_alert: false
        }
    ];
    tva: Tva[] = [];
    dataError: {
        type : string;
        logo: string;
        nom: string;
        tva: string;
        prix_unitaires: string;
        marge: string;
        prix_vente: string;
        list: string;
        montant: string;
        ref: string,
        bascul_calcul: string,
        regle: string,
        entrepot : string,
        min : string,
        max : string,
        priceBlockErrors: PriceBlockError[];
        warehouseBlockErrors: WarehouseBlockErrors[];

    } =
        {
            type :'',
            logo: '',
            nom: '',
            tva: '',
            prix_unitaires: '',
            marge: '',
            prix_vente: '',
            list: '',
            montant: '',
            ref: '',
            bascul_calcul: '',
            regle: '',
            entrepot : '',
            min : '',
            max : '',
            priceBlockErrors: [],
            warehouseBlockErrors : []
        };
    steps: string[] = [
        'Type de produit',
        ' Informations sur le produit',
        ' Informations supplémentaires',
        ' Terminé'
    ];
    allSections: { id: number; type: 'listePrix' | 'inf' ; isContentVisible: boolean }[] = [];
    sectionCounter: number = 1;
    selectedTaxeIds: number[] = [];
    priceLists: any[] = [];
    informationsLogistique: any[] = [];

    infoLogistique: any[] = [];

    constructor( private modalService: NgbModal,
                 private toastr: ToastrService,
                 private productsService: ProductsService,
                 private taxeService: TaxeService,
                 private prixService: PrixService,
                 private tvaService: TvaService,
                 private cdr: ChangeDetectorRef,
                 private stationService: StationService,
                 @Inject(ERP_AFFICHAGES_API) private api: ErpAffichagesApi) { }

  ngOnInit(): void {
  }
    ngAfterViewInit(): void {
        this.api.onTvaAdded().subscribe(() => this.loadTVA());
        if (this.addtaxe?.taxeAdded) {
            this.addtaxe.taxeAdded.subscribe(() => this.loadTaxe());
        }
    }
    openModal() {

        const options: NgbModalOptions = {
            centered: true,
            scrollable: true,
            backdrop: 'static',
            keyboard: true,
          //  size: 'xl',
            windowClass: 'modal-wide-1000'
        };
        this.modalRef = this.modalService.open(this.modalTemplate, options);
        this.allSections = [
            { id: 1, type: 'listePrix', isContentVisible: false },
            { id: 2, type: 'inf', isContentVisible: false }
        ];

        this.product.prix_unitaires = 0;
        this.product.result_ht = 0;
        this.product.result_ttc = 0;
        this.product.tva_id = 0;
        this.product.taxe_id = 0;

        this.priceLists = [{
            selectedPriceId: null,
            prix_id: null,
            bascul_calcul: 'prix_public',
            regles: 'fixe',
            montant: null,
            result_ht: 0,
            result_ttc: 0
        }];

        // Chargement des données → le calcul se fera dans loadTVA/loadTaxe
        this.loadTVA();
        this.loadTaxe();
        this.loadPrix();

        this.cdr.detectChanges();
    }

    clearFieldError(fieldName: string): void {
        if (this.dataError[fieldName]) {
            this.dataError[fieldName] = '';
        }
    }

    onTvaChange(): void {
        this.calculateFinalPrice();
        this.recalculateAllPriceLists();
    }


    calculatePublicPrices(): void {
        this.public_ht = this.product.result_ht;
        this.public_ttc = this.product.result_ttc;
    }

    calculateResults(i: number): void {
        const price = this.priceLists[i];

        if (!price.bascul_calcul || !price.montant) {
            return;
        }

        const montant = Number(price.montant);

        // Cas A: Base = "Prix public"
        if (price.bascul_calcul === 'prix_public') {
            if (price.regles === 'fixe') {
                // Règle = "Spécification fixe"
                price.result_ht = this.public_ht + montant;
                price.result_ttc = this.public_ttc + montant;
            } else if (price.regles === 'pourcentage') {
                // Règle = "Pourcentage"
                const pourcentageDecimal = montant / 100;
                price.result_ht = this.public_ht * (1 + pourcentageDecimal);
                price.result_ttc = this.public_ttc * (1 + pourcentageDecimal);
            }
        }
        // Cas B: Base = "Arbitraire"
        else if (price.bascul_calcul === 'arbitraires') {
            this.calculateArbitraryPrice(i);
        }

        // Formater les résultats
        price.result_ht = Number(price.result_ht.toFixed(2));
        price.result_ttc = Number(price.result_ttc.toFixed(2));
    }
    calculateArbitraryPrice(i: number): void {
        const price = this.priceLists[i];
        const tvaObj = (this.tva || []).find((x: any) => Number(x.id) === Number(this.product.tva_id));
        const tvaRate = tvaObj ? Number(tvaObj.valeur) : 0;

        const taxeObj = (this.taxes || []).find((x: any) => Number(x.id) === Number(this.product.taxe_id));
        const taxeRate = taxeObj ? Number(taxeObj.valeur || 0) : 0;

        const totalRate = (tvaRate + taxeRate) / 100;
        const montant = Number(price.montant) || 0;

        // Use individual priceType for each price list
        if (this.priceType2 === 'TTC') {
            // Si saisie en TTC
            price.result_ttc = montant;
            price.result_ht = +(montant / (1 + totalRate)).toFixed(2);
        } else {
            // Si saisie en HT
            price.result_ht = montant;
            price.result_ttc = +(montant * (1 + totalRate)).toFixed(2);
        }
    }
    onArbitraryPriceTypeChange(i: number): void {
        const price = this.priceLists[i];
        // Mettre à jour saisie_type en fonction de priceType individuel
        price.saisie_type = price.priceType;
        this.calculateResults(i); // Recalculer les résultats
    }
    calculateFromMarginPercentage() {
        // Calculates Prix Vente
        if (this.product.prix_unitaires !== null && this.margePourcentage !== null) {
            let prixVenteCalculated = this.product.prix_unitaires * (1 + this.margePourcentage / 100);

            // Appliquer 3 décimales et reconvertir en nombre
            this.prixVente = Number(prixVenteCalculated.toFixed(3));
        }
    }

    calculateFromSellingPrice() {
        // Calculates Marge %
        if (this.product.prix_unitaires !== null && this.prixVente !== null && this.product.prix_unitaires > 0) {
            let margeCalculated = ((this.prixVente - this.product.prix_unitaires) / this.product.prix_unitaires) * 100;

            // Appliquer 3 décimales et reconvertir en nombre
            this.margePourcentage = Number(margeCalculated.toFixed(3));
        } else {
            this.margePourcentage = 0;
        }
    }

    calculateFinalPrice(): void {
        const prix = Number(this.product.prix_unitaires) || 0;

        const tvaObj = (this.tva || []).find(
            (x: any) => Number(x.id) === Number(this.product.tva_id)
        );
        const tvaRate = tvaObj ? Number(tvaObj.valeur) : 0;

        const taxeObj = (this.taxes || []).find(
            (x: any) => Number(x.id) === Number(this.product.taxe_id)
        );
        const taxeRate = taxeObj ? Number(taxeObj.valeur || 0) : 0;

        // Debug: log the rates
        console.log('TVA Rate:', tvaRate);
        console.log('Taxe Rate:', taxeRate);
        console.log('Total Rate:', (tvaRate + taxeRate) / 100);

        const totalRate = (tvaRate + taxeRate) / 100;

        if (this.priceType === 'HT') {
            this.product.result_ht = prix;
            this.product.result_ttc = +(prix * (1 + totalRate)).toFixed(2);
            console.log('HT->TTC Calculation:', prix, '×', (1 + totalRate), '=', this.product.result_ttc);
        } else {
            this.product.result_ttc = prix;
            this.product.result_ht = +(prix / (1 + totalRate)).toFixed(2);
            console.log('TTC->HT Calculation:', prix, '÷', (1 + totalRate), '=', this.product.result_ht);
        }

        this.calculatePublicPrices();
    }

    recalculateAllPriceLists(): void {
        this.priceLists.forEach((price, index) => {
            if (price.bascul_calcul && price.montant) {
                this.calculateResults(index);
            }
        });
    }

    toggleListePrixBox(): void {
        const id = this.sectionCounter++;
        this.allSections.push({ id, type: 'listePrix', isContentVisible: true });
        this.priceLists.push({
            date_reglement: '',
            bascul_calcul: 'prix_public',
            regles: 'fixe',
            montant: null,
            result_ht: 0,
            result_ttc: 0
        });
        this.cdr.detectChanges();
    }

    toggleInfBox(): void {
        const id = this.sectionCounter++;
        this.allSections.push({ id, type: 'inf', isContentVisible: true });
        this.informationsLogistique.push({
            entrepot_id: null,
            minimum: 0,
            maximum: 0,
            description: ''
        });
        this.cdr.detectChanges();
    }

    removeSection(index: number): void {
        this.allSections.splice(index, 1);
        if (index === 0) {
            this.priceLists.splice(0, 1);
        } else {
            this.infoLogistique.splice(0, 1);
        }
    }

    toggleTaxe(taxeId: number, checked: boolean): void {
        if (checked) {
            if (!this.selectedTaxeIds.includes(taxeId)) {
                this.selectedTaxeIds.push(taxeId);
            }
        } else {
            this.selectedTaxeIds = this.selectedTaxeIds.filter(id => id !== taxeId);
        }
        this.onTvaChange();
    }

    onPriceTypeChange(): void {
        this.calculateFinalPrice();
        this.recalculateAllPriceLists();
    }

    addListePrix(): void {
        const id = this.sectionCounter++;
        this.allSections.push({ id, type: 'listePrix', isContentVisible: false });
        this.priceLists.push({
            date_reglement: '',
            bascul_calcul: 'prix_public',
            regles: 'fixe',
            montant: 0,
            result_ht: 0,
            result_ttc: 0
        });
        this.cdr.detectChanges();
    }

    addInfoLogistique(): void {
        const id = this.sectionCounter++;
        this.allSections.push({ id, type: 'inf', isContentVisible: false });
        this.infoLogistique.push({
            entrepot_id: null,
            minimum: 0,
            maximum: 0,
            description: '',
            is_active_alert: false
        });
        this.cdr.detectChanges();
    }

    toggleContent(sectionId: number): void {
        const section = this.allSections.find(s => s.id === sectionId);
        if (section) section.isContentVisible = !section.isContentVisible;
    }


    calculatePriceList(i: number): void {
        // Réutilise ta logique existante calculateResults(i)
        this.calculateResults(i);
    }
    addPriceList() {
        if (this.priceLists.length < 3) {
            this.priceLists.push({
                prix_id: 0,
                bascul_calcul: 'prix_public',
                liste: null,
                regles: 'fixe',
                montant: 0,
                result_ttc: 0,
                result_ht: 0,
                priceType: 'HT',
                saisie_type: 'HT',
                selectedPriceId: null
            });
        } else {
            //this.toasterInfo("Vous ne pouvez pas ajouter plus de 3.");
        }
    }
    removePriceList(index: number) {
        if (this.priceLists.length > 1) {
            this.priceLists.splice(index, 1);
        }
    }
    onMinusClick(i: number, price: any) {
        const hasSelection = price.selectedPriceId || price.montant;
        const onlyOne = this.priceLists.length === 1;

        if (onlyOne && hasSelection) {
            this.clearPriceListSelection(i);
        } else {
            this.removePriceList(i);
        }
    }
    clearPriceListSelection(index: number) {
        if (this.priceLists[index]) {
            // Clear the Type selection
            this.priceLists[index].selectedPriceId = null;

            // Reset the other fields
            // this.priceLists[index].bascul_calcul = null;
            // this.priceLists[index].regles = null;
            this.priceLists[index].montant = null;
            this.priceLists[index].result_ttc = 0;
            this.priceLists[index].result_ht = 0;
            this.clearFieldError('montant');
            this.clearFieldError('bascul_calcul');
            this.clearFieldError('regle');
            this.clearFieldError('list');

        }
    }
    onPriceSelected(index: number, selectedId: number): void {
        this.priceLists[index].prix_id = selectedId;
        this.cdr.detectChanges();
    }
    onBaseCalculChange(i: number): void {
        const price = this.priceLists[i];

        if (price.bascul_calcul === 'arbitraires') {
            // Réinitialiser les règles pour arbitraire
            price.regles = 'fixe';
            price.montant = null;
            price.result_ht = 0;
            price.result_ttc = 0;
            // Set default price type for arbitrary
            price.priceType = 'HT';
        } else {
            // Réinitialiser pour prix public
            price.montant = null;
            price.result_ht = 0;
            price.result_ttc = 0;
        }

        // Recalculate if there's any amount
        if (price.montant) {
            this.calculateResults(i);
        }
    }
    incrementAmount(index: number) {
        this.priceLists[index].montant++;
        this.calculateResults(index);
        this.clearFieldError('montant');
    }

    decrementAmount(index: number): void {
        if (this.priceLists[index].montant > 1) {
            this.priceLists[index].montant--;
            this.calculateResults(index);
            this.clearFieldError('montant');
        }
    }


    loadTVA(): void {
        this.isLoading = true;
        this.tvaService.getTvaList(this.stationId).subscribe({
            next: (data: any) => {
                this.tva = (data.tvaListe || []).filter((t: any) => t.statut === true);
                 console.log("TVA actives :", this.tva);
                this.isLoading = false;
               // this.cd.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des TVA');
                this.isLoading = false;
              //  this.cd.detectChanges();
            }
        });
    }

    loadTaxe(): void {
        this.isLoading = true;
        this.taxeService.getTaxeList(this.stationId).subscribe({
            next: (data: any) => {
                const list = data?.taxes || [];

                this.taxes = list.filter((t: any) => {
                    const statut = t.statut === true || t.statut === 1 || t.statut === '1' || t.statut === 'true';
                    const applique = t.taxe_applique_sur_produits === true || t.taxe_applique_sur_produits === 1 || t.taxe_applique_sur_produits === '1' || t.taxe_applique_sur_produits === 'true';
                    return statut && applique;
                });

                this.isLoading = false;
            },
            error: () => {
                this.toastr.error('Erreur lors du chargement des taxes');
                this.isLoading = false;
            }
        });
    }


    loadPrix(): void {
        this.isLoading = true;
        this.prixService.getPrix(this.stationId).subscribe({
            next: (data: any) => {
                const allPrices = data.prixListe || data;
                this.availablePriceLists = allPrices.filter((price: any) => price.statut === true);
                this.isLoading = false;
                this.cdr.detectChanges();
            },
            error: (err) => {
                this.toastr.error('Erreur lors du chargement des listes de prix');
                this.isLoading = false;
            }
        });
    }

    onPrixAchatChange(): void {
        // Empêche les valeurs négatives
        if (this.product.prix_unitaires < 0) {
            this.product.prix_unitaires = 0;
        }

        // Recalcule tout
        this.calculateFinalPrice();
        this.recalculateAllPriceLists();
    }
    productType: 'matériel' | 'service' | null = null;

    selectType(type: 'matériel' | 'service') {
        this.productType = type;
        this.product.type = type;
        this.dataError.type = '';

    }

    saveProduct(): void {
        if (!this.validateProductData()) {
            this.toastr.error('Veuillez remplir tous les champs obligatoires');
            return;
        }

        this.isLoading = true;

        const productToSave = this.prepareProductData();

        this.productsService.addProduct(this.stationId, productToSave)
            .pipe(
                finalize(() => {
                    this.isLoading = false;
                })
            )
            .subscribe({
                next: (response) => {
                    this.toastr.success('Produit ajouté avec succès');

                    const newProduct = response?.product || response?.data;

                    this.closeModal.emit({
                        success: true,
                        product: newProduct,
                        productId: newProduct?.id
                    });

                    this.modalRef?.close();

                },
                error: (err) => {
                    console.error('Erreur lors de l\'ajout:', err);
                    this.toastr.error(
                        err.error?.message || 'Erreur lors de l\'ajout du produit'
                    );
                }
            });
    }


    onClose(): void {
        this.closeModal.emit({ success: false });
    }

    private validateProductData(): boolean {
        if (!this.product.type) {
            this.toastr.error('Le type de produit est requis');
            return false;
        }
        if (!this.product.nom || this.product.nom.trim() === '') {
            this.toastr.error('Le nom du produit est requis');
            return false;
        }
        if (!this.product.prix_unitaires) {
            this.toastr.error('Le prix unitaire est requis');
            return false;
        }

        return true;
    }
    private prepareProductData(): any {
        const productData = {
            type: this.product.type,
            nom: this.product.nom,
            tva_id: this.product.tva_id,
            taxe_id: this.product.taxe_id,
            prix_unitaires: this.product.prix_unitaires,
            result_ht : this.product.result_ht,
            result_ttc : this.product.result_ttc,
            autoriser_vente_stock_vide : this.product.autoriser_vente_stock_vide,
            produit_avec_numero_serie : this.product.produit_avec_numero_serie,
            image: this.product.image,
            marque_id: this.product.marque_id,
            categories_id: this.product.categories_id,
            unite_id: this.product.unite_id,
            ref_interne: this.product.ref_interne,
            ref_fabricant: this.product.ref_fabricant,
            description: this.product.description,
            station_id: this.stationId,
            client_id: this.clientId,
            liste_prix: this.preparePriceLists(),
            information_logistique: this.product.type === 'matériel' ? this.prepareWarehouses() : []
        };

        // console.log('Warehouses data prepared:', productData.information_logistique);
        return productData;
    }

    private preparePriceLists(): any[] {
        if (!this.priceLists || this.priceLists.length === 0) {
            return [];
        }
        return this.priceLists
            .filter(price => price.montant != null && true)
            .map(price => ({
                prix_id: price.prix_id,
                bascul_calcul: price.bascul_calcul,
                regles: price.regles,
                montant: Number(price.montant),
                result_ttc: price.result_ttc || 0,
                result_ht: price.result_ht || 0,
                client_id: this.clientId,
                station_id: this.stationId
            }));
    }

    private prepareWarehouses(): any[] {
        // console.log('Current warehouses array:', this.warehouses);

        // Filter out warehouses without a valid entrepot_id
        const validWarehouses = this.warehouses.filter(warehouse =>
            warehouse.entrepot_id && warehouse.entrepot_id > 0
        );

        // console.log('Valid warehouses:', validWarehouses);

        const warehousesData = validWarehouses.map(warehouse => ({
            entrepot_id: warehouse.entrepot_id,
            minimum: warehouse.minimum,
            maximum: warehouse.maximum,
            is_active_alert: warehouse.is_active_alert || false,
            client_id: this.clientId,
            station_id: this.stationId
        }));

        // console.log('Prepared warehouses data:', warehousesData);
        return warehousesData;
    }
}
